import React            from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App             from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import rootReducer from './reducer';
import {createStore, applyMiddleware, compose} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import logger from 'redux-logger';

// Apply persisted theme to <body> before first paint to avoid a light-mode flash.
try {
    const storedMode = window.localStorage.getItem('scc.themeMode');
    document.body.setAttribute('data-scc-theme', storedMode === 'dark' ? 'dark' : 'light');
} catch (e) {
    document.body.setAttribute('data-scc-theme', 'light');
}


// 배포 레벨에서는 리덕스 발동시 찍히는 logger를 사용하지 않습니다.
const enhancer =
	process.env.NODE_ENV === 'production'
		? compose(applyMiddleware())
		: composeWithDevTools(applyMiddleware(logger));

const store = createStore(rootReducer, enhancer);
const root = ReactDOM.createRoot(document.getElementById('root'));

console.log('process.env.NODE_ENV : ', process.env.NODE_ENV);
if (process.env.NODE_ENV == 'production') {
	console.log = () => {};
}
root.render(
	<Provider store={store}>
    <App />
	</Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
